import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchResultTeaser } from '../../../molecules/SearchResultTeaser/SearchResultTeaser';
import { ContentList, ContentListItem } from '../../../../_lib/components/ContentList';
import ContentSearchResultTable from './partials/ContentSearchResultTable';
import { murmurhash } from '../../../../lib/js/hash';
import { ContentParagraph } from '../../../../_lib/components/ContentParagraph';
import { Namespace } from '../../../../translation/namespace';
import ILink from '../../../../types/ILink';
import { LoadMoreButtonType } from '../../../../_lib/components/LoadMore/partials/LoadMoreButton';
import { LoadMore } from '../../../../_lib/components/LoadMore/LoadMore';
import { useLoadMore } from '../../../../_lib/components/LoadMore/useLoadMore';
import { ResultContent } from '../../../../types/Search.types';

type ContentSearchResultsProps = {
  blockLayout?: string;
  resultContents?: ResultContent[];
  searchListTemplate?: string;
  originalSearchUrl?: string;
  loadMore?: LoadMoreButtonType;
};

export default function ContentSearchResults({
  blockLayout = undefined,
  resultContents = [],
  searchListTemplate = undefined,
  originalSearchUrl = undefined,
  loadMore = undefined,
}: ContentSearchResultsProps) {
  const { t } = useTranslation(Namespace.ContentSearchResults);

  const { resultList, loadingStatus, loadMoreStatus, itemToBeFocused, listContainerRef, listItemRef, loadMoreItems } =
    useLoadMore<ResultContent>(loadMore, resultContents);

  const isTable = (contentDate?: string, pageLink?: ILink) => {
    return !blockLayout || (typeof contentDate !== 'undefined' && typeof pageLink !== 'undefined');
  };

  if (!resultList || resultList.length === 0) {
    return null;
  }

  if (isTable(resultContents[0].contentDate, resultContents[0].pageLink)) {
    return (
      <>
        <ContentSearchResultTable items={resultContents} />
        {/* originalSearchUrl is included for migrated search list from on2 richtext content see SON-10763 */}
        {originalSearchUrl && <ContentParagraph>{`(${t('originalSearch')}: ${originalSearchUrl}`})</ContentParagraph>}
      </>
    );
  }

  return (
    <LoadMore
      loadMore={loadMore}
      loadMoreStatus={loadMoreStatus}
      loadMoreItems={loadMoreItems}
      loadingStatus={loadingStatus}
      ref={listContainerRef}
    >
      <ContentList>
        {resultList.map((element, index) => (
          <ContentListItem
            key={murmurhash(element.pageLink.url) + index}
            ref={
              itemToBeFocused && loadingStatus === 'success' && index === itemToBeFocused - 1 ? listItemRef : undefined
            }
          >
            <SearchResultTeaser {...element} searchListTemplate={searchListTemplate} />
          </ContentListItem>
        ))}
      </ContentList>
    </LoadMore>
  );
}
